import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import DatePicker from "react-date-picker";
import {
  DocumentDownloadIcon,
  QuestionMarkCircleIcon,
  SearchIcon,
} from "@heroicons/react/solid";
import { convert, formatDate } from "../../utils/convertDate";
import { FormatMoney } from "../../utils/formatMoney";
import GeneralTable from "../../components/GeneralTable";
import { useNavigate } from "react-router-dom";
import TreasuryBillClass from "../../services/treasuryBill";

const oldFrom = new Date().setDate(new Date().getDate() - 7);
const defaultTo = formatDate(new Date());
const longNew = formatDate(defaultTo);
const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7));
const longDate = formatDate(defaultFrom);

const TreasuryBookings = () => {
  const navigate = useNavigate();

  const [searchTreasuryBills, setSearchTreasuryBills] = useState("");
  // const [selectedTenorClass, setSelectedTenorClass] = useState(""); // Removed: New state for tenor class
  const [too, setToo] = useState(convert(longNew));
  const [fromm, setFromm] = useState(convert(longDate));
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date(),
  });
  const [selectedStatus, setSelectedStatus] = useState(""); // New state for status filter

  const [bookingData, setBookingData] = useState([]);

  // State for pagination
  const [pageIndex, setPageIndex] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPreviousPage, setHasPreviousPage] = useState(false);
  const itemsPerPage = 10;

  // Pagination handlers
  const prevPage = () => {
    if (pageIndex > 1) {
      setPageIndex(pageIndex - 1);
    }
  };

  const nextPage = () => {
    if (hasNextPage) {
      setPageIndex(pageIndex + 1);
    }
  };

  const handleSetPageIndex = (page) => {
    setPageIndex(page);
  };

  // Define columns
  const columns = [
    { key: "security", header: "Security" },
    {
      key: "faceValue",
      header: "Face Value",
      render: (item) => FormatMoney(item.faceValue, "NGN"),
    },
    { key: "customerName", header: "Customer Name" },
    { key: "accountNumber", header: "Account Number" },
    { key: "emailAddress", header: "Email Address" },
    {
      key: "tenor",
      header: "Tenor",
      render: (item) => item.tenor + " " + "days",
    },
    {
      key: "discountRate",
      header: "Discount Rate",
      render: (item) => item.discountRate + "%",
    },
    {
      key: "settlementDate",
      header: "Settlement Date",
      render: (item) =>
        item.settlementDate === "0001-01-01T00:00:00"
          ? "-"
          : formatDate(item.settlementDate),
    },
    {
      key: "maturityDate",
      header: "Maturity Date",
      render: (item) =>
        item.maturityDate === "0001-01-01T00:00:00"
          ? "-"
          : formatDate(item.maturityDate),
    },
    { key: "redemptionValue", header: "Redemption Value" },
    { key: "yield", header: "Yield", render: (item) => item.yield + "%" },
    {
      key: "status",
      header: "Status",
      render: (item) => {
        const status = item?.status?.toLowerCase() || "";
        const statusColors = {
          notset: "text-gray-500 font-semibold",
          started: "text-blue-500 font-semibold",
          pending: "text-yellow-500 font-semibold",
          processed: "text-green-500 font-semibold",
          liquidationrequested: "text-purple-500 font-semibold",
          matured: "text-indigo-500 font-semibold",
          failed: "text-red-500 font-semibold",
        };
        const colorClass =
          statusColors[status] || "text-gray-500 font-semibold";
        return <span className={colorClass}>{item.status || "-"}</span>;
      },
    },
    // { key: 'action', header: 'Action'}
  ];

  const GetBookings = async (
    page,
    pageSize,
    search,
    startDate,
    endDate,
    status
  ) => {
    const response = await TreasuryBillClass.ListOfBookings(
      page,
      pageSize,
      search,
      startDate,
      endDate,
      status
    );
    if (response && response.status) {
      setBookingData(response.data.result);

      // Set pagination data from API response
      setTotalPages(response.data.totalPages || 1);
      setTotalCount(response.data.totalCount || 0);
      setHasNextPage(response.data.hasNextPage || false);
      setHasPreviousPage(response.data.hasPreviousPage || false);
    }
  };

  useEffect(() => {
    GetBookings(pageIndex, itemsPerPage, "", fromm, too, selectedStatus);
  }, [pageIndex, itemsPerPage, fromm, too, selectedStatus]);

  const range = async (e) => {
    e.preventDefault();
    GetBookings(
      pageIndex,
      itemsPerPage,
      searchTreasuryBills,
      fromm,
      too,
      selectedStatus
    );
  };

  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event });
      setFromm(formatDate(event));
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event });
      setToo(formatDate(event));
    },
  };

  const exportCSV = async () => {
    const resp = await TreasuryBillClass.exportTreasuryBookings(
      searchTreasuryBills,
      fromm,
      too,
      selectedStatus
    );
    if (resp) {
      window.open(resp.data);
    }
  };

  // Define actions
  const actions = ["View Booking", "Resend Booking Advise"];

  // Handle action selection
  const handleActionSelect = async (action, item) => {
    if (action.toLowerCase() === "view booking") {
      navigate(`/bookings/${item?.id}`);
    } else {
      const response = await TreasuryBillClass.resendBookingAdvise(item?.id);
      if (response) {

      }
    }
  };

  return (
    <Layout
      title="Bookings"
      pageTag={"treasury_bill"}
      current={"/treasury/bookings"}
    >
      <React.Fragment>
        <main className="mt-5">
          <div className="sm:flex sm:items-center justify-between flex-wrap">
            {/* Filter Section */}
            <div className="sm:flex-auto flex items-end flex-wrap gap-3">
              {" "}
              {/* Aligned items to end for consistent baseline */}
              <div className=" relative rounded-md shadow-sm ">
                <p className="text-sm leading-3 text-gray-500">From</p>
                <div>
                  <DatePicker
                    onChange={dateValidation.fromHandler}
                    value={formValues.from}
                  />
                </div>
              </div>
              <div className=" relative rounded-md shadow-sm ">
                <p className="text-sm leading-3 text-gray-500">To</p>
                <div>
                  <DatePicker
                    onChange={dateValidation.toHandler}
                    value={formValues.to}
                  />
                </div>
              </div>
              {/* Removed Tenor Class Filter */}
              {/* <div className=" relative rounded-md shadow-sm ">
                                <p className='text-sm leading-3 text-gray-500'>Tenor Class</p>
                                <div>
                                    <select
                                        id="tenorClass"
                                        name="tenorClass"
                                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                        value={selectedTenorClass}
                                        onChange={(e) => setSelectedTenorClass(e.target.value)}
                                    >
                                        <option value="">Select Tenor Class</option>
                                        <option value="<90">less than 90 days</option>
                                        <option value="<150">less than 150 days</option>
                                        <option value="<365">less than 365 days</option>
                                    </select>
                                </div>
                            </div> */}
              {/* Status Filter */}
              <div className=" relative rounded-md shadow-sm ">
                <p className="text-sm leading-3 text-gray-500">Status</p>
                <div>
                  <select
                    id="statusFilter"
                    name="statusFilter"
                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                  >
                    <option value="">--</option>
                    <option value="NotSet">NotSet</option>
                    <option value="Started">Started</option>
                    <option value="Pending">Pending</option>
                    <option value="Processed">Processed</option>
                    <option value="LiquidationRequested">
                      LiquidationRequested
                    </option>
                    <option value="Matured">Matured</option>
                    <option value="Failed">Failed</option>
                  </select>
                </div>
              </div>
              <div className="flex gap-3">
                <div className=" relative rounded-md shadow-sm ">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <SearchIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </div>
                  <input
                    type="text"
                    name="user"
                    id="user"
                    onChange={(e) => setSearchTreasuryBills(e.target.value)}
                    className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                    placeholder="Search bookings"
                  />
                  <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                    <div className="tooltip">
                      <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                      <span className="tooltiptext">
                        {" "}
                        <p>Search treasury bills</p>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="">
                  {" "}
                  {/* Removed mt-5 and ml-4 to align better with flex-end */}
                  <button
                    onClick={range}
                    className="hover:text-white active:text-white inline-flex items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>

            {/* Action Buttons Section */}
            <div className="mt-5 sm:ml-16 sm:flex-none flex items-center gap-3">
              {" "}
              {/* Added flex and gap-3 for consistent spacing */}
              <button
                type="button"
                onClick={exportCSV}
                className="inline-flex items-center hover:text-white active:text-white justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm  sm:w-auto"
              >
                <DocumentDownloadIcon className="w-4 mr-1.5" />
                Export CSV
              </button>
            </div>
          </div>

          {/* table */}
          <GeneralTable
            columns={columns}
            data={bookingData}
            nextPage={hasNextPage}
            pageIndex={pageIndex}
            totalCount={totalCount}
            totalPages={totalPages}
            prevPage={prevPage}
            setPageIndex={handleSetPageIndex}
            actions={actions}
            onActionSelect={handleActionSelect}
          />
        </main>
      </React.Fragment>
    </Layout>
  );
};

export default TreasuryBookings;
